
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/driver-analysis-continous/create",
      function () {
        return require("private-next-pages/driver-analysis-continous/create.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/driver-analysis-continous/create"])
      });
    }
  